const Search = {
  init() {
    Search.events();
  },

  events() {
    // Handle search button press.
    $(".search__button").on("click", function (e) {
      e.preventDefault();
      const query = $(".search__input").val();
      Search.handleSearch(query);
    });

    // Handle Enter key press in the input field.
    $(".search__input").on("keypress", function (e) {
      if (e.which === 13) {
        const query = $(".search__input").val();
        Search.handleSearch(query);
        e.preventDefault();
      }
    });
  },

  /**
   * Create url with search query
   */
  handleSearch(searchQuery) {
    const currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.set("search", searchQuery);
    const url = window.location.pathname + "?" + currentSearchParams.toString();

    // Redirect to the new URL
    window.location.href = url;
  },
};

export default Search;
